import { useCallback } from 'react';

import { isIn } from '../../utils/array';
import { useTranslations } from '../use-translations';

export function useGetGateTypeString(): (gateType: string | null | undefined) => string {
  const t = useTranslations('dictionaries.gateType');

  return useCallback(
    (gateType) => {
      return isIn(gateType, ['invoice', 'withdraw']) ? t(gateType) : (gateType ?? '');
    },
    [t]
  );
}
